module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-top": "150px"
    },
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('p', [_c('em', [_vm._v("This is a story of how abandonment, betrayal, and eventually courage can foster the birth of a renewed soul and mind through the passageway of forgiveness. Birthed Anew is the portrayed revelation of one’s authentic journey through self-identification, self-reflection, self-expression, self-discovery, self-renewal, and lastly the pinnacle of self-love which is the key ingredient to the development of a whole person. The bitterness of life can afford the opportunity to seek growth and betterment as we aim to maximize our truest and fullest potential as essential contributors to society.")])]), _vm._v(" "), _c('p', [_c('em', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394e5b3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0003.vue
// module id = 81
// module chunks = 0